import instance from "..";
import { createQueryString } from "src/utils/helper";
import { setBookingsList } from "src/reducers/bookings";
import { dummyBookings } from "src/constants/dummyBookings";

// ✅ GET BOOKINGS
export const getBookingsListAction: any =
  (apiData) => async (dispatch: any) => {
    try {
      const query = createQueryString(apiData);

      const res = await instance.get(
        `/api/v1/admin/bookings?${query}`
      );

      const apiResponse = res?.data;

      if (
        !apiResponse?.success ||
        !apiResponse?.data ||
        !apiResponse?.data?.data
      ) {
        dispatch(setBookingsList(dummyBookings));
        return dummyBookings;
      }

      const formattedData = {
        data: apiResponse.data.data.map((item: any) => ({
          id: item.id,

          parentName: item.parent?.fullName,
          parentPhone: item.parent?.phone,

          childName: item.child?.fullName,
          grade: item.child?.grade,
          emergencyName: item.child?.emergencyContactName,
          emergencyPhone: item.child?.emergencyContactPhone,

          addressLat: item.address?.latitude,
          addressLng: item.address?.longitude,

          schoolLat: item.school?.latitude,
          schoolLng: item.school?.longitude,

          // ✅ captain mapping
          driverId: item.captain?.id ? String(item.captain.id) : "",
          captainName: item.captain?.fullName,

          // ✅ status string
          status: item.captain ? "Assigned" : "Pending",
        })),
        total: apiResponse.data.total,
      };

      dispatch(setBookingsList(formattedData));
      return formattedData;
    } catch (err) {
      dispatch(setBookingsList(dummyBookings));
      return dummyBookings;
    }
  };

// ✅ ASSIGN CAPTAIN
export const assignDriverAction: any =
  ({ bookingId, captainId }) =>
  async () => {
    try {
      if (!bookingId || !captainId) {
        throw new Error("Invalid bookingId or captainId");
      }

      const res = await instance.put(
        `/api/v1/admin/bookings/${bookingId}/assign-captain?captainId=${captainId}`
      );

      return res.data;
    } catch (err: any) {
      throw err?.response?.data || err;
    }
  };

    // ✅ GET CAPTAINS DROPDOWN
  export const getCaptainsDropdownAction: any = () => async () => {
    try {
      const res = await instance.get(`/api/v1/admin/captains/dropdown`);
  
      const apiResponse = res?.data;
  
      if (!apiResponse?.success || !apiResponse?.data) {
        return [];
      }
  
      // ✅ Format for dropdown
      return apiResponse.data.map((item: any) => ({
        label: `${item.fullName} (${item.phone})`,
        value: item.id,
        name: item.fullName,
        phone: item.phone,
      }));
    } catch (err: any) {
      throw err?.response?.data || err;
    }
  };